module.exports = __webpack_public_path__ + "static/media/60810002-FDD0wSgs.c28adfc2.JPG";